import { RELATIONSHIP_TO_PATIENT_NAME_V4, RelationshipToPatientV4 } from '@tempus/patient-forms-service-shared';

import { FormTableFieldFrontend } from '../../shared/FormTable';

type FieldValidator = NonNullable<FormTableFieldFrontend['validate']>;

export const isTempusRepresentative = (allValues: Record<string, any>): boolean =>
  allValues[RELATIONSHIP_TO_PATIENT_NAME_V4] === RelationshipToPatientV4.TEMPUS_REPRESENTATIVE;

/**
 * Not required of a Tempus representative, who transcribes a paper application and only has the
 * fields the patient filled in. Values they do enter are still validated.
 */
export const optionalForTempusRepresentative = (validate: FieldValidator): FieldValidator => (
  value,
  allValues,
  meta,
) => {
  if (!value && isTempusRepresentative(allValues)) {
    return undefined;
  }

  return validate(value, allValues, meta);
};
